import { render, staticRenderFns } from "./MachineCol.vue?vue&type=template&id=747ae952&scoped=true"
import script from "./MachineCol.vue?vue&type=script&lang=js"
export * from "./MachineCol.vue?vue&type=script&lang=js"
import style1 from "./MachineCol.vue?vue&type=style&index=1&id=747ae952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747ae952",
  null
  
)

export default component.exports